import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material"

import PageWrapper from "Pages/@PageWrapper"
import {MONITORING_ROUTES} from "@constants"
import {isLoadingCommonFilters, isSystemBusy} from "@signals";
import MonitoringResultsFilters from "./Filters";
import {monitoringResultsIsEmpty, resetMonitoringResults, monitoringResultsDataLimit} from "./@signals";
import MonitoringResultsTable from "./Table";
import MonitoringResultsFooterInfo from "./FooterInfo";
import MonitoringResultsReportForm from "./ReportForm";
import MonitoringResultsIssueModal from "./IssuesModal";
import MonitoringResultsRefreshDataModal from "./RefreshDataModal";

export default function MonitoringResultsPage() {

    useEffect(() => {
        return () => resetMonitoringResults()
    },[])

    useEffect(() => {
        if (isLoadingCommonFilters.value && monitoringResultsIsEmpty.value)
            monitoringResultsIsEmpty.value = false
    }, [isLoadingCommonFilters.value])

    const LIMIT_SEARCHES = [{
        title: "Warning Filters",
        message: 'Results are limited in each country tab to 1,000. Please refine your filters for better accuracy.',
        severity: 'warning'
    }]

    return <PageWrapper
        isEmpty={monitoringResultsIsEmpty.value}
        head={`DIP Insight | ${MONITORING_ROUTES.OVERVIEW_TITLE}`}
        title={MONITORING_ROUTES.OVERVIEW_TITLE}
        subtitle={MONITORING_ROUTES.OVERVIEW_SUBTITLE}
        filters={<MonitoringResultsFilters />}
        actions={null}
        hasErrors={isSystemBusy.value}
        globalMessages={monitoringResultsDataLimit.value && LIMIT_SEARCHES}
        tourPageKey="monitoringResults"
    >
        <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item xs={12} data-tour="monitoring-results-table">
                <MonitoringResultsTable />
            </Grid>
            <Grid item xs={12} data-tour="monitoring-results-footer">
                <MonitoringResultsFooterInfo />
            </Grid>
        </Grid>

        <MonitoringResultsReportForm />
        <MonitoringResultsIssueModal />
        <MonitoringResultsRefreshDataModal />
    </PageWrapper>
}